<template>
    <div style="height: 100dvh">
        <NuxtPwaManifest />
        <NuxtLayout>
            <Toast />
            <div v-show="$pwa.needRefresh">
                <span>Nuovi contenuti disponibili. Si prega di aggiornare la pagina.</span>

                <button @click="$pwa.updateServiceWorker()">Ricarica</button>
            </div>
            <NuxtPage />
        </NuxtLayout>

        <PwaUpdateDialog />
    </div>
</template>

<script setup>
import { useToast } from 'primevue/usetoast';
import { usePrimeVue } from 'primevue/config';

const { $pwa, $localStorage } = useNuxtApp();
const { setLocale } = useI18n();
const config = useRuntimeConfig();
const BASE_PROGETTO = config.public.base_progetto;
const primevue = usePrimeVue();
const toast = useToast();
const languages = [{ value: 'it' }, { value: 'en' }, { value: 'fr' }];
const translationObj = ref(null);
const route = useRoute();

// Check for updates every time the user navigates
watch(
    () => route.path,
    async () => {
        if ($pwa && 'getRegistration' in $pwa) {
            const registration = await $pwa.getRegistration();
            // This triggers the browser to check the server for a new sw-notifications.js
            await registration?.update();
        }
    }
);

onMounted(async () => {
    try {
        const response = await fetch('/languages/translation.json');
        translationObj.value = await response.json();
    } catch (error) {
        translationObj.value = null;
    } finally {
        applyLanguage();
    }
});

async function applyLanguage() {
    const languageLocalStorage = $localStorage.getItem('selectedLanguage') || 'it';
    setTranslations(languageLocalStorage);
    await setLocale(languageLocalStorage);
}

function setTranslations(language) {
    const translations = translationObj.value?.[language];
    if (!translations) return;
    Object.assign(primevue.config.locale, translations);
}
</script>
